import p1 from './assets/images/towerofhanoi.png'
import p2 from './assets/images/todolist.png'
import p3 from './assets/images/awesomebooks.png'
// import p4 from './assets/images/budget_app.png'
import p5 from './assets/images/resturant_menu.png'
import p6 from './assets/images/space_travelers_hub.png'
import p7 from './assets/images/bookstore.png'
import p8 from './assets/images/country_fact.png'
import p9 from './assets/images/math_magician.png'
import p10 from './assets/images/science_and_technology_summit.png' 
// import p11 from './assets/images/english_is_fun.png' 
import p12 from './assets/images/drawing_app.png'
import p13 from './assets/images/isp.png'

const  projects = [
    {   
        id:1,
        img:p2,
        name:'To do List',
        discription: 'The Tower of Hanoi is a classic game of logical thinking and sequential reasoning. Move rings from one tower to another but make sure you follow the rules! ,built with vanilla JavaScript',
        liveDomo: 'https://yasinabdmahmood.github.io/To-do-list/dist/',
        gitHubLink: 'https://github.com/yasinabdmahmood/To-do-list',
        technologies:['HTML5','CSS3','JavaScript']
    },
    {   
        id:2,
        img:p3,
        name:'Awesome books',
        discription: 'The Tower of Hanoi is a classic game of logical thinking and sequential reasoning. Move rings from one tower to another but make sure you follow the rules! ,built with vanilla JavaScript',
        liveDomo: 'https://yasinabdmahmood.github.io/Awesome-books/',
        gitHubLink: 'https://github.com/yasinabdmahmood/Awesome-books',
        technologies:['HTML5','CSS3','JavaScript']
    },
    // the following project is not working because the postgres database is not working
    // {   
    //     id:3,
    //     img:p4,
    //     name:'Budget app',
    //     discription: 'Budget app is a mobile web application where you can manage your budget: you have a list of transactions associated with a category, so that you can see how much money you spent and on what.',
    //     liveDomo: 'https://budget-app-microverse.onrender.com',
    //     gitHubLink: 'https://github.com/yasinabdmahmood/Budget-app',
    //     technologies:['Ruby on rails','HTML5','CSS3','Bootstrap']
    // },

    {   
        id:5,
        img:p6,
        name:"Space Traveler's Hub",
        discription: 'This web application provides commercial and scientific space travel services. The application allows users to book rockets and join selected space missions.',
        liveDomo: 'https://633d3d1994ebcf57859df1b2--glistening-zuccutto-a1444a.netlify.app/',
        gitHubLink: 'https://github.com/yasinabdmahmood/Space-Travelers-Hub',
        technologies:['React','Redux']
    },
    {   
        id:6,
        img:p7,
        name:"Bookstore",
        discription: 'Bookstore is an app that lets you list you favorate books with thier respective author name , you can add new book or delete a book on demand',
        liveDomo: 'https://bookstore-yaseen.netlify.app/',
        gitHubLink: 'https://github.com/yasinabdmahmood/Bookstore',
        technologies:['React','Redux']
    },
    {   
        id:7,
        img:p8,
        name:"Country facts",
        discription: 'Continents facts is a a React and Redux SPA application that dispalys interesting information about various countries in the world. It gets all the information that it displays using API request to a server.',
        liveDomo: 'https://tubular-cupcake-f62e8d.netlify.app/',
        gitHubLink: 'https://github.com/yasinabdmahmood/Country-facts',
        technologies:['React','Redux','CSS']
    },
    {   
        id:8,
        img:p9,
        name:"Math magicians",
        discription: 'Math magicians" is a website for all fans of mathematics. It is a Single Page App (SPA) that allows users to Make simple calculationsm and Read a random math-related quote.',
        liveDomo: 'https://nimble-lamington-32e434.netlify.app/',
        gitHubLink: 'https://github.com/yasinabdmahmood/math_magicians',
        technologies:['React','JavaScript','CSS']
    },
    {   
        id:9,
        img:p10,
        name:"Science and Technology summit",
        discription: 'This project is a website dedicated to the Science and Technology Summit 2022 conference. The website contains all the information you need to know about the conference, including the schedule, speakers, and other important details.',
        liveDomo: 'https://yasinabdmahmood.github.io/Capstone-Project/',
        gitHubLink: 'https://github.com/yasinabdmahmood/Capstone-Project',
        technologies:['HTML5','CSS3','JavaScript']
    },
    // {   
    //     id:10,
    //     img:p11,
    //     name:"English is fun",
    //     discription: `English is fun is a web application designed to help English language learners improve their vocabulary and descriptive skills. The app provides users with a random word generated by OpenAI's API endpoint, which the user must then describe in their own words using the input field provided. To cater to the user's level of proficiency, English is fun and allows the user to choose the difficulty level of the word, ranging from A1 (easiest) to C2 (most advanced). Once the user submits their description, the app makes an API call to OpenAI's API endpoint to evaluate the accuracy and quality of the description. The evaluation is then displayed to the user as feedback, with a score on a scale of 1 to 10. English is fun easy to use and accessible to learners of all levels. Whether you're just starting or looking to improve your existing skills, English is fun and is a great tool for anyone looking to improve their English language proficiency. So why wait? Start practicing your English skills today English is fun!`,
    //     liveDomo: 'https://english-is-fun.netlify.app/',
    //     gitHubLink: 'https://github.com/yasinabdmahmood/english-is-fun',
    //     technologies:['React','CSS3','Next.js']
    // },
    {   
        id:0,
        img:p1,
        name:'Tower of hanoi',
        discription: 'The Tower of Hanoi is a classic game of logical thinking and sequential reasoning. Move rings from one tower to another but make sure you follow the rules! ,built with vanilla JavaScript',
        liveDomo: 'https://yasinabdmahmood.github.io/Tower-of-Hanoi/src/',
        gitHubLink: 'https://github.com/yasinabdmahmood/Tower-of-Hanoi',
        technologies:['HTML5','CSS3','JavaScript']
    },
    {   
        id:4,
        img:p5,
        name:'Restaurant menu',
        discription: 'The web app functions as a digital menu for restaurants and cafes that allows you to view what is on their menu with pictures, descriptions, and prices. the user can also start ordering foods and drinks with the desired amount.',
        liveDomo: 'https://aesthetic-queijadas-f18c90.netlify.app/',
        gitHubLink: 'https://github.com/yasinabdmahmood/react-resturant-menu',
        technologies:['React','Redux','Sass']
    },
    {   
        id:11,
        img:p12,
        name:'Drawing app',
        discription: 'Unleash your creativity with HappyDrawing, a versatile React drawing app. Create stunning designs, sketches, and doodles with customizable features and a wide color palette. Start your artistic journey today!',
        liveDomo: 'https://happydrawing.netlify.app/',
        gitHubLink: 'https://github.com/yasinabdmahmood/react-drawing-app',
        technologies:['React','Redux','CSS3']
    },
    {   
        id:12,
        img:p13,
        name:'Subscription Management System for ISP',
        discription: `
        A robust, real-time platform built to streamline subscription handling for Internet Service Providers. This system automates new subscriptions, renewals, and payment tracking—empowering employees to manage customer data effortlessly. It features a powerful reporting dashboard for daily and monthly insights, helping teams make data-driven decisions. Built with Ruby on Rails, PostgreSQL, and a responsive React + Redux front end, it offers a smooth user experience with role-based access, boosting operational efficiency by over 300%.
        `,
        liveDomo: 'https://isp.yyaassiinn.xyz/',
        gitHubLink: 'https://github.com/yasinabdmahmood/ISP-managment-system',
        technologies:['Rails','PostgreSQL','React','Redux','CSS3']
    },
    
 ]

 export default projects